import { render } from "./source-code.vue?vue&type=template&id=17b4b1f4&scoped=true"
import script from "./source-code.vue?vue&type=script&lang=js"
export * from "./source-code.vue?vue&type=script&lang=js"

import "./source-code.vue?vue&type=style&index=0&id=17b4b1f4&lang=scss&scoped=true"

import exportComponent from "/Users/liupingping/work/3/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b4b1f4"]])

export default __exports__